/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * This js file has to be loaded first
 */
h5 = h5 || {};
h5.networkLibUi = {
   angularModule: angular.module('com.vmware.vsphere.client.networkLibUi', [
      'com.vmware.platform.ui'])
};
